var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsBuildingOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Building") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M79,81V31.5A4.51,4.51,0,0,0,74.5,27h-9V18A4.51,4.51,0,0,0,61,13.5H29.5A4.51,4.51,0,0,0,25,18V81H16v4.5H88V81Zm-4.5,0h-45V18H61V31.5H74.5ZM36.25,65.25h4.5v-4.5h-4.5Zm0-18h4.5v-4.5h-4.5Zm0-18h4.5v-4.5h-4.5Zm13.5,40.5h4.5v-9h-4.5Zm0-22.5h4.5v-4.5h-4.5Zm0-18h4.5v-4.5h-4.5Zm13.5,36h4.5v-4.5h-4.5Zm0-18h4.5v-4.5h-4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsBuildingOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Building_Outline_Black_RGB.1f4f4be363dc64eb22484e7b678a352b.svg";
export { ForwardRef as ReactComponent };